<template>
  <div>
    <div class="mt-5 hist_area mb-5">
      <div class="hist_item mb-5" v-for="(item, i) in group" :key="i">
        <div class="hist_year mb-1">{{ item.year }}年</div>
        <div class="hist_item mb-2" v-for="(child, i) in item.child" :key="i">
          <div class="hist_date ml-5">
            {{ child.month ? child.month + "月" : "" }}
          </div>
          <div class="hist_text ml-10" v-html="child.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firestore from "@/js/firebase";
export default {
  name: "Histry",
  data: () => ({
    histData: [],
    group: [],
  }),
  created() {
    this.get();
  },
  methods: {
    get: function() {
      const s = this;
      firestore
        .collection("histry")
        .get()
        .then(function(querySnapshot) {
          s.histData = [];
          querySnapshot.forEach(function(doc) {
            let data = doc.data();
            data.id = doc.id;
            s.histData.push(data);
          });
          s.grouping();
        });
    },
    grouping: function() {
      const s = this;
      let group = s.histData.reduce(function(result, current) {
        let element = result.find(function(p) {
          return p.year === current.year;
        });
        if (element) {
          element.child.push(current);
        } else {
          result.push({
            year: current.year,
            child: [current],
          });
        }
        return result;
      }, []);
      group.sort(function(a, b) {
        if (a.year < b.year) return 1;
        if (a.year > b.year) return -1;
        return 0;
      });
      group.forEach((element) => {
        element.child.sort(function(a, b) {
          const aa = Number(a.month.split('~')[0])
          const bb = Number(b.month.split('~')[0])
          if (aa < bb) return -1;
          if (aa > bb) return 1;
          return 0;
        });
      });
      s.group = group;
    },
  },
};
</script>

<style scoped>
.hist_area {
  max-width: 400px;
  margin: auto;
}
.hist_year {
  font-size: 18px;
  font-weight: bold;
}
.hist_date {
  font-size: 14px;
}
.hist_text {
  font-size: 14px;
  white-space: pre-wrap;
}
</style>
